import { render, staticRenderFns } from "./zxView.vue?vue&type=template&id=872e694e&scoped=true"
import script from "./zxView.vue?vue&type=script&lang=js"
export * from "./zxView.vue?vue&type=script&lang=js"
import style0 from "./zxView.vue?vue&type=style&index=0&id=872e694e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872e694e",
  null
  
)

export default component.exports